import React from 'react';
import {
  Container,
  Paper,
  Typography,
  Button,
  Box,
  Card,
  CardContent,
} from '@mui/material';
import { Block as BlockIcon, Logout as LogoutIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { Logo } from '@horwath-htl/shared-branding';

export const AccessDeniedPage: React.FC = () => {
  const navigate = useNavigate();
  const { instance } = useMsal();

  const handleLogout = async () => {
    try {
      // Log out the user
      await instance.logoutRedirect({
        postLogoutRedirectUri: window.location.origin, // Redirect to root after logout
      });
    } catch (error) {
      console.error('Logout failed:', error);
      // Fallback: navigate to root anyway
      navigate('/');
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Card sx={{ textAlign: 'center', p: 4 }}>
        <CardContent>
          <Box sx={{ mb: 4 }}>
            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
              <Logo variant="full" height={50} />
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
              <BlockIcon sx={{ fontSize: 64, color: 'error.main' }} />
            </Box>
            <Typography
              variant="h4"
              component="h1"
              gutterBottom
              fontWeight="normal"
            >
              Access Denied
            </Typography>
            <Typography variant="h6" component="h2" gutterBottom color="text.secondary">
              This portal is restricted
            </Typography>
          </Box>

          <Paper sx={{ p: 3, mb: 4, bgcolor: 'error.50', border: '1px solid', borderColor: 'error.main' }}>
            <Typography variant="body1" gutterBottom fontWeight="medium">
              This portal is only available to Horwath HTL and Barrett HTL employees.
            </Typography>
          </Paper>

          <Button
            variant="contained"
            size="large"
            startIcon={<LogoutIcon />}
            onClick={handleLogout}
            sx={{
              py: 1.5,
              px: 4,
              borderRadius: 2,
              textTransform: 'none',
              fontSize: '1.1rem',
            }}
          >
            Sign Out
          </Button>

        </CardContent>
      </Card>
    </Container>
  );
};